module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<%\n  var hasDescription = !!description.length;\n  var hasSponsor = (sponsor === '1' && sponsor_image.length);\n%> <div class=\"description-wrapper\"> <% if( hasDescription ) { %> <p class=\"cat-description\"><%- description %></p> <% } %> <% if( hasSponsor ) { %> <div class=\"sponsor\"> <span><%- (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text %></span> <img src=\"<%= sponsor_image %>\" alt=\"\"> </div> <% } %> </div> <% if( copy.live_vote_url ) { %> <div class=\"live-vote\"> <a href=\"<%= copy.live_vote_url %>\" target=\"_blank\" class=\"live-vote-btn\" style=\"background: <%= copy.live_vote_button_background %>\"><img src=\"<%= copy.live_vote_icon_url %>\" alt=\"<%= copy.live_vote_icon_alt %>\"> <%- copy.live_vote_button_text %></a> </div> <% } %> <div class=\"finalists\"></div> <div class=\"runner-up\"> <h1><%- copy.subheadline %></h1> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1;
  var hasDescription = !!description.length;
  var hasSponsor = (sponsor === '1' && sponsor_image.length);
; buf.push(' <div class="description-wrapper"> ');__stack.lineno=4; if( hasDescription ) { ; buf.push(' <p class="cat-description">', (__stack.lineno=4,  description ), '</p> ');__stack.lineno=4; } ; buf.push(' ');__stack.lineno=4; if( hasSponsor ) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=4,  (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text ), '</span> <img src="', escape((__stack.lineno=4,  sponsor_image )), '" alt=""> </div> ');__stack.lineno=4; } ; buf.push(' </div> ');__stack.lineno=4; if( copy.live_vote_url ) { ; buf.push(' <div class="live-vote"> <a href="', escape((__stack.lineno=4,  copy.live_vote_url )), '" target="_blank" class="live-vote-btn" style="background: ', escape((__stack.lineno=4,  copy.live_vote_button_background )), '"><img src="', escape((__stack.lineno=4,  copy.live_vote_icon_url )), '" alt="', escape((__stack.lineno=4,  copy.live_vote_icon_alt )), '"> ', (__stack.lineno=4,  copy.live_vote_button_text ), '</a> </div> ');__stack.lineno=4; } ; buf.push(' <div class="finalists"></div> <div class="runner-up"> <h1>', (__stack.lineno=4,  copy.subheadline ), '</h1> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/live-vote.ejs
// module id = 248
// module chunks = 0